import { withTimeout } from "./with-timeout";

/**
 * Starting the meeting while microphone selection is pending lets the SDK queue
 * a silent fallback behind the real selection, replacing the working input.
 * Settle selection first, with a deadline so denial cannot block receiving media.
 */
export async function startWithMicrophone({
  microphone,
  timeoutMs,
  isActive,
  onFailure,
  start,
}: {
  microphone: Promise<void>;
  timeoutMs: number;
  isActive: () => boolean;
  onFailure: (error: unknown) => void;
  start: () => void;
}): Promise<void> {
  try {
    await withTimeout(microphone, timeoutMs, "Microphone");
  } catch (error) {
    if (!isActive()) return;
    onFailure(error);
  }
  if (isActive()) start();
}
